import { z } from 'zod';

export const GpsCoordinatesSchema = z.object({
  latitude: z.number().min(-90).max(90),
  longitude: z.number().min(-180).max(180),
  accuracy: z.number().nonnegative(), // en metros
  altitude: z.number().nullable().optional(),
  altitudeAccuracy: z.number().nullable().optional(),
  heading: z.number().min(0).max(360).nullable().optional(),
  speed: z.number().nonnegative().nullable().optional(),
  timestamp: z.number().int().positive()
});

export const DeviceStatusSchema = z.object({
  batteryLevel: z.number().min(0).max(1).nullable().optional(),
  isCharging: z.boolean().nullable().optional(),
  networkType: z.enum(['4g', '3g', '2g', 'wifi', 'unknown']).optional(),
  activeCamera: z.enum(['user', 'environment']).optional(),
  torchActive: z.boolean().optional(),
  zoomFactor: z.number().min(1).max(10).optional()
});

export type GpsCoordinates = z.infer<typeof GpsCoordinatesSchema>;
export type DeviceStatus = z.infer<typeof DeviceStatusSchema>;
